<template>
  <div>
    <div ref="contextMenu" class="text-sm bg-trans rounded overflow-hidden fixed z-50  no-select">
      <div
        class="bg-trans-item px-4 py-1 text-xs cursor-pointer hover:bg-blue-500 hover:text-white active:bg-white"
        :class="[i==2 ? 'border-b border-gray-400' :'', i==0 ? 'rounded-t':'', i==menus.length-1 ? 'rounded-b' :''  ]"
        v-for="(menu,i) of menus"
        :key="i"
        @click="onClick($event,menu)"
      >{{menu}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { UiSelect } from "./../util";
export default {
  name: "ContextMenu",
  props: {},
  data() {
    return {
      menus: [
        "Copy",
        "Paste",
        "Delete",
        "Select Children",
        "Select Parent",
        "Make Component"
      ]
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["selectedNodes"])
  },
  methods: {
    ...mapActions([
      "copy",
      "paste",
      "deleteNode",
      "selectChildren",
      "selectParent"
    ]),
    onClick(event, menu) {
      this.$emit("click", menu);
      switch (menu) {
        case "Copy":
          this.copy();
          break;

        case "Paste":
          this.paste();
          break;
        case "Delete":
          this.deleteNode(this.selectedNodes);
          break;
        case "Select Parent":
          this.selectParent({ children: this.selectedNodes });
          break;
        case "Select Children":
          this.selectChildren({ parentNode: this.selectedNodes });
          break;
        case "Make Component":
          break;
        default:
          break;
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bg-trans {
-webkit-box-shadow: 0px 0px 33px 2px rgba(0,0,0,0.36);
-moz-box-shadow: 0px 0px 33px 2px rgba(0,0,0,0.36);
box-shadow: 0px 0px 33px 2px rgba(0,0,0,0.36);
}
.bg-trans,
.bg-trans-item {
  background: rgba(240, 240, 240, 1);
}
.bg-trans-item:hover {
  background: rgb(59, 93, 208);
}
</style>
